export const az = {
    newsEnd: 'Daha xəbər yoxdur...',
    quickLinks: 'Sürətli keçidlər',
    contacts: 'Əlaqə',
    socialMedias: 'Sosial şəbəkələr',
    mainNews: 'Əsas xəbərlər',
    rubrics: 'Rubrikalar',
    siteCreatedBy: 'Saytı hazırlamışdır: ',
    projectTarget: 'Layihənin məqsədi:',
    targetText: 'Yeni texnologiyaların sürətlə inkişaf etdiyi müasir dövrdə xüsusi qabiliyyətə malik yeniyetmə və gənclərin cəmiyyətə tanıdılması, onların intellektual fəaliyyətlərinin təbliği və stimullaşdırılması.',
    companyText: 'Sayt Azərbaycan Respublikasının Qeyri-Hökumət Təşkilatlarına Dövlət Dəstəyi Agentliyinin maliyyə yardımı ilə hazırlanmışdır.Saytda əks olunan fikir və mülahizələr müəllifə aiddir və Azərbaycan Respublikasının Qeyri- Hökumət Təşkilatlarına Dövlət Dəstəyi Agentliyinin rəsmi mövqeyini əks etdirmir.',
	chevik: 'Chevik.az layihəsi © Bütün hüquqlar qorunur'
}